import { MiniCompareDataPointsConfig, MiniCompareTableDataConfig } from './mini-compare-table-data-config';

export const miniCompareTableDataPointsList: MiniCompareDataPointsConfig = {
	dataPoints: [
		'performance',
		'estimatedRisk',
		'expenseRatio',
		'tradeFrequency',
		'riskProfile'
	],
	optionalDataPoints: [
		'objective',
		'preferences',
		'vehicle',
		'thirdPartyFunds',
		'modelCategoryType',
		// 'grossYTDReturn',
		// 'netYTDReturn',  commenting out for now for the pilot, will be included in the FF 
		'performanceBenchmark'
	]

};

export const miniCompareTableGrossDataPoints: MiniCompareDataPointsConfig = {
	dataPoints: [
		'grossPerformance',
		'estimatedRisk',
		'expenseRatio',
		'tradeFrequency',
		'riskProfile'
	],
	optionalDataPoints: [
		'objective',
		'preferences',
		'vehicle',
		'thirdPartyFunds',
		'modelCategoryType',
		// 'grossYTDReturn',
		'performanceBenchmark'
	]
};

export const miniCompareTableData: MiniCompareTableDataConfig = {
	performance: {
		dataKey: 'yearToDate',
		label: {
			dcrKey: 'MINI_COMPARE_GROSS_NET_PERFORMANCE_LABEL',
			dcrValue: 'Annualized Gross/ Net YTD Performance'
		},
		tooltip: {
			dcrKey: 'MINI_COMPARE_GROSS_NET_PERFORMANCE_TOOLTIP',
			dcrValue: 'MINI_COMPARE_GROSS_NET_PERFORMANCE_TOOLTIP'
		},
		twinPropertyKey: 'customNetYearToDate',
		asOfDateKey: 'ytdReturnAsOfDate'
	},
	grossPerformance: {
		dataKey: 'yearToDate',
		label: {
			dcrKey: 'MINI_COMPARE_GROSS_PERFORMANCE_LABEL',
			dcrValue: 'Annualized Performance'
		},
		tooltip: {
			dcrKey: 'MINI_COMPARE_GROSS_PERFORMANCE_TOOLTIP',
			dcrValue: 'MINI_COMPARE_GROSS_PERFORMANCE_TOOLTIP'
		},
		asOfDateKey: 'ytdReturnAsOfDate'
	},
	estimatedRisk: {
		dataKey: 'estimatedRisk',
		label: {
			dcrKey: 'MINI_COMPARE_ESTIMATED_RISK_LABEL',
			dcrValue: 'Estimated Risk'
		},
		tooltip: {
			dcrKey: 'MINI_COMPARE_ESTIMATED_RISK_TOOLTIP',
			dcrValue: 'MINI_COMPARE_ESTIMATED_RISK_TOOLTIP'
		},
		asOfDateKey: 'estimatedRiskAsOfDate',
		subText: {
			dcrKey: 'MINI_COMPARE_ESTIMATED_RISK_SUB_TEXT',
			dcrValue: '(Powered by Aladdin)'
		}
	},
	expenseRatio: {
		dataKey: 'grossExpenseRatio',
		label: {
			dcrKey: 'MINI_COMPARE_EXPENSE_RATIO_LABEL',
			dcrValue: 'Gross/Net Expense Ratio'
		},
		tooltip: {
			dcrKey: 'MINI_COMPARE_EXPENSE_RATIO_TOOLTIP',
			dcrValue: 'MINI_COMPARE_EXPENSE_RATIO_TOOLTIP'
		},
		twinPropertyKey: 'expenseRatio',
		asOfDateKey: 'expenseRatioAsOfDate'
	},
	tradeFrequency: {
		dataKey: 'tradeFrequency',
		label: {
			dcrKey: 'MINI_COMPARE_TRADE_FREQUENCY_LABEL',
			dcrValue: 'Trade Frequency'
		},
		isDcrDriven: true
	},
	riskProfile: {
		dataKey: 'riskProfile',
		label: {
			dcrKey: 'MINI_COMPARE_RISK_PROFILE_LABEL',
			dcrValue: 'Risk Profile'
		},
		isDcrDriven: true
	},
	objective: {
		dataKey: 'objective',
		label: {
			dcrKey: 'MINI_COMPARE_OBJECTIVE_LABEL',
			dcrValue: 'Objective'
		}
	},
	preferences: {
		dataKey: 'preferences',
		label: {
			dcrKey: 'MINI_COMPARE_PREFERENCE_LABEL',
			dcrValue: 'Preference'
		},
		isDcrDriven: true
	},
	vehicle: {
		dataKey: 'vehicle',
		label: {
			dcrKey: 'MINI_COMPARE_VEHICLE_LABEL',
			dcrValue: 'Vehicle'
		},
		isDcrDriven: true
	},
	thirdPartyFunds: {
		dataKey: 'openArchitecture',
		label: {
			dcrKey: 'MINI_COMPARE_THIRD_PARTY_FUNDS_LABEL',
			dcrValue: '3rd Party Funds'
		}
	},
	modelCategoryType: {
		dataKey: 'modelCategoryType',
		label: {
			dcrKey: 'MINI_COMPARE_MODEL_CATEGORY_TYPE_LABEL',
			dcrValue: 'Model Category Type'
		},
		isDcrDriven: true
	},
	grossYTDReturn: {
		dataKey: 'ytdReturn',
		label: {
			dcrKey: 'MINI_COMPARE_GROSS_YTD_RETURNS_LABEL',
			dcrValue: 'Gross YTD Return'
		},
		tooltip: {
			dcrKey: 'MINI_COMPARE_GROSS_YTD_RETURNS_TOOLTIP',
			dcrValue: 'MINI_COMPARE_GROSS_YTD_RETURNS_TOOLTIP'
		},
		asOfDateKey: 'ytdReturnAsOfDate'
	},
	netYTDReturn: {
		dataKey: 'customNetYearToDate',
		label: {
			dcrKey: 'MINI_COMPARE_NET_YTD_RETURNS_LABEL',
			dcrValue: 'Net YTD Return'
		},
		tooltip: {
			dcrKey: 'MINI_COMPARE_NET_YTD_RETURNS_TOOLTIP',
			dcrValue: 'MINI_COMPARE_NET_YTD_RETURNS_TOOLTIP'
		},
		asOfDateKey: 'ytdReturnAsOfDate'
	},
	performanceBenchmark: {
		dataKey: 'benchmarkYearToDate',
		label: {
			dcrKey: 'MINI_COMPARE_PERFORMANCE_BENCHMARK_LABEL',
			dcrValue: 'Performance Benchmark'
		},
		asOfDateKey: 'ytdReturnAsOfDate'
	}
};
